export default __webpack_public_path__ + "static/media/img-0012.851ce5d1.png";